<template>
    <div ref="brief" class="content-font bg-darker bg-cover"
         style="width:100%;max-width: 600px;box-sizing: border-box;border:0px;position: relative;"  v-bind:style="{ backgroundImage: 'url(' + image + ')',paddingTop: $mq === 'sm'?'':'50%'}">
        <div class="flex-center text-center"
             style="width:100%;height:100%;top:0px;padding:50px;box-sizing: border-box;background-color: rgba(0, 0, 0, 0.3);" v-bind:style="{position: $mq === 'sm'?'':'absolute'}">

            <div class="font-slogan" v-if="quote!==null">{{quote}}</div>
            <br/>
            {{text}}
        </div>
    </div>
</template>

<script>
	export default {
		name: "CoverCard",
        props:{
			quote:String,
            text:String,
            image:String
        }
	}
</script>

<style scoped>

</style>